import { render, staticRenderFns } from "./relievePreservationDetail.vue?vue&type=template&id=f3facb04&scoped=true&lang=html&"
import script from "./relievePreservationDetail.vue?vue&type=script&lang=js&"
export * from "./relievePreservationDetail.vue?vue&type=script&lang=js&"
import style0 from "./relievePreservationDetail.vue?vue&type=style&index=0&id=f3facb04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3facb04",
  null
  
)

export default component.exports